import {
  ButtonEditorIconGrid,
  ButtonEditorIconPlacement,
  ButtonEditorSettingToggle,
} from '@/components/shared/button-editor';
import { BUTTON_TYPE_OPTIONS } from '@/components/shared/button-editor-popover';
import { SelectInput, TextInput } from '@/components/ui/form';
import {
  type CollectionButtonIconPlacement,
  type CollectionButtonSettings,
  type CollectionButtonStyle,
  DEFAULT_COLLECTION_BUTTON_SETTINGS,
} from '@/lib/blocks/collection/button-settings';

interface ButtonTabProps {
  buttonSettings: CollectionButtonSettings;
  onButtonSettingsChange: (patch: Partial<CollectionButtonSettings>) => void;
}

export function ButtonTab({ buttonSettings, onButtonSettingsChange }: ButtonTabProps) {
  const hasIcon = buttonSettings.icon !== null;

  return (
    <div className="space-y-4">
      <TextInput
        label="Button Text"
        value={buttonSettings.text}
        placeholder={DEFAULT_COLLECTION_BUTTON_SETTINGS.text}
        onChange={(e) => onButtonSettingsChange({ text: e.target.value })}
      />

      <SelectInput
        label="Button Type"
        value={buttonSettings.style}
        onValueChange={(value) => onButtonSettingsChange({ style: value as CollectionButtonStyle })}
        searchable={false}
        contentClassName="z-[150]"
        options={BUTTON_TYPE_OPTIONS}
      />

      <div className="space-y-4">
        <ButtonEditorSettingToggle
          title="Icon"
          description="Include an icon in the button"
          checked={hasIcon}
          onCheckedChange={(checked) =>
            onButtonSettingsChange(
              checked
                ? { icon: 'phone', iconPlacement: buttonSettings.iconPlacement || 'after' }
                : { icon: null },
            )
          }
        />

        {hasIcon ? (
          <>
            <ButtonEditorIconGrid
              value={buttonSettings.icon ?? undefined}
              onValueChange={(icon) => onButtonSettingsChange({ icon })}
            />

            <ButtonEditorIconPlacement
              value={buttonSettings.iconPlacement}
              onValueChange={(value) =>
                onButtonSettingsChange({ iconPlacement: value as CollectionButtonIconPlacement })
              }
            />
          </>
        ) : null}
      </div>
    </div>
  );
}
